(function() {
	// globals
	window.EWO.Users = {};

	//module functions
	EWO.MD({
		global: EWO.Users,
		name: 'users',
		containerClass: 'js-users',
		listTemplate: '/app/users/templates/users.ejs',
		createOrEditTemplate: '/app/users/templates/usersCreateOrEdit.ejs',
		createOrEditValidationRules: {
			rules: {
				username: 'required',
				language: 'required',
				email: 'required email',
				rolesIds: 'required'
				//password: 'required'
			}
		},
		createOrEditAdditionalData: function(id) {
			var d = $.Deferred();
			$.when(
				$.get(EWO.config.apiUrlPrefix + '/roles'),
				$.get(EWO.config.apiUrlPrefix + '/settings?key=PASSWORD_RESET_ADMIN')
			)
			.done(function(roles, setting) {
				d.resolve({
					roles: roles[0].rows,
					setting: setting[0].rows
				});
			})
			.fail(function() {
				d.reject();
			});
			return d;
		},
		createOrEditCallback: function(id) {
			$('#roles').select2();
		},
		beforeSaveCallback: function(detail) {
			if (detail.rolesIds && !$.isArray(detail.rolesIds)) {
				detail.rolesIds = [detail.rolesIds];
			}
			return detail;
		},
		apiRoot: EWO.config.apiUrlPrefix + '/users',
		routingRoot: '/users'
	});

	//events
	$(document).on('click', '.js-users .js-passwordreset', function(ev) {
		ev.preventDefault();
		var ids = [];
		$('.user_checkbox input:checked').each(function() {
			ids.push($(this).attr('data-id'));
		});

		$.ajax({
			url: EWO.config.apiUrlPrefix + '/credentials/reset?ids=' + ids.join(','),
			type: 'POST',
			data: {},
			contentType: 'application/json; charset=UTF-8'
		})
		.done(function(response) {
			PNotify.success('Comunicazioni inviate');
		})
		.fail(function(e) {
			PNotify.error(e.responseText);
		});
	});

	$(document).on('click', '.js-users .js-sendusernames', function(ev) {
		ev.preventDefault();
		var ids = [];
		$('.user_checkbox input:checked').each(function() {
			ids.push($(this).attr('data-id'));
		});

		$.ajax({
			url: EWO.config.apiUrlPrefix + '/credentials/sendusernames?ids=' + ids.join(','),
			type: 'POST',
			data: {},
			contentType: 'application/json; charset=UTF-8'
		})
		.done(function(response) {
			PNotify.success('Comunicazioni inviate');
		});

	});

	$(document).on('change', '.js-users #checkAll', function(ev) {
		var value = $(this).prop('checked');
		$('.user_checkbox input').each(function() {
			$(this).prop('checked', value);
		});
		updateSelectedCount();
	});

	$(document).on('change', '.js-users .user_checkbox input', function() {
		updateSelectedCount();
	});

	// Funzione per aggiornare il conteggio degli utenti selezionati
	function updateSelectedCount() {
		var count = $('.user_checkbox input:checked').length;
		$('.js-selected-count').text(count);
	}

	function updateTable() {
		var datatable = $('.js-users .dataTable');
			var dtoptions = {};
			if (datatable.length > 0) {
				dtoptions.order = datatable.DataTable().order();
				dtoptions.page = datatable.DataTable().page();
				dtoptions.pageLength = datatable.DataTable().page.len();
				dtoptions.lengthMenu = datatable.DataTable().lengthMenu;
			}
			// Aggiorna l'URL con le opzioni della tabella
			var search = document.location.search;
			if (!$.isEmptyObject(dtoptions)) {
				var urlQueryString = new URLSearchParams(search);
				if (urlQueryString.has('dt')) {
					urlQueryString.delete('dt');
					var t = urlQueryString.toString();
					if (t) {
						search = '?' + t;
					} else {
						search = '';
					}
				}
				search = (search ? search + '&' : '?') + 'dt=' + encodeURIComponent(JSON.stringify(dtoptions));
			}
			page(document.location.pathname + search);
	}
	
	// Funzione per chiudere correttamente la modale
	function closeModal() {
		$('#massDeleteModal').modal('hide');
	}

	$(document).on('click', '.js-confirm-massdelete', function(ev) {
		ev.preventDefault();
		
		var ids = [];
		$('.user_checkbox input:checked').each(function() {
			ids.push($(this).attr('data-id'));
		});

		if (ids.length === 0) {
			PNotify.error(i18next.t('No users selected'));
			closeModal();
			return;
		}

		$.ajax({
			url: EWO.config.apiUrlPrefix + '/users/bulk',
			type: 'DELETE',
			data: JSON.stringify(ids),
			contentType: 'application/json; charset=UTF-8'
		})
		.done(function(response) {
			closeModal();
			var undoNotice = i18next.t('Users deleted. Do you want to <a href="javascript:///" class="js-massundo" data-ids="' + ids.join(',') + '">undo</a>?');
			var notification = PNotify.success({
				text: undoNotice,
				textTrusted: true,
				addClass: 'js-users js-massundo-' + ids.join('-')
			});
			$('.js-users.js-massundo-' + ids.join('-')).data('pnotify', notification);
			// Ricarica la lista degli utenti mantenendo lo stato della tabella
			updateTable();
		})
		.fail(function(e) {
			closeModal();
			PNotify.error(e.responseText || i18next.t('Error deleting users'));
		});
	});

	// Gestione della chiusura della modale con il pulsante Cancel
	$(document).on('click', '#massDeleteModal .btn-secondary', function() {
		closeModal();
	});

	// Gestione della chiusura della modale con il pulsante X
	$(document).on('click', '#massDeleteModal .close', function() {
		closeModal();
	});

	// Gestione dell'undo per cancellazione massiva
	$(document).on('click', '.js-users .js-massundo', function(ev) {
		ev.preventDefault();
		var ids = $(this).attr('data-ids').split(',');
		
		$.ajax({
			url: EWO.config.apiUrlPrefix + '/users/undodelete/bulk',
			type: 'POST',
			data: JSON.stringify(ids),
			contentType: 'application/json; charset=UTF-8'
		})
		.done(function(response) {
			// Chiudi la notifica
			$('.js-users.js-massundo-' + ids.join('-')).data('pnotify').remove();
			PNotify.success(i18next.t('Users restored successfully'));
			// Ricarica la lista degli utenti mantenendo lo stato della tabella
			updateTable();
		})
		.fail(function(e) {
			PNotify.error(e.responseText || i18next.t('Error restoring users'));
		});
	});

	$(document).on('change', '.js-users #change-password', function() {
		if ($('.js-changepassword').hasClass('d-none')) {
			$('.js-changepassword').removeClass('d-none');
			$('#change-password').prop('checked', true);
		} else {
			$('.js-changepassword').addClass('d-none');
			$('#change-password').prop('checked', false);
		}
		$('.js-users .js-editform').valid();
	});

	//routing
})();
